import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useUpdateData } from "hooks/useApiHooks";

const EditSessionPage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/sessions"; // Endpoint untuk sesi

  // State form untuk menyimpan nama sesi dan jumlah ATV
  const [formData, setFormData] = useState({
    sessionName: "",
    availableATV: 0,
  });

  // Apakah ini dalam mode edit?
  const isUpdateMode = !!initialData;

  // Hook untuk update data
  const { updateData: updateSession, loading: updatingSession } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "sessions"
  );

  // Gunakan handler bawaan untuk perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Handler untuk submit data
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    updateSession,
    onSuccess,
    onError
  );

  // Fungsi untuk submit dengan payload
  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formData };
    handleSubmit(payload, e);
  };

  // Jika ada `initialData`, isi form dengan data awal
  useEffect(() => {
    if (initialData) {
      setFormData({
        sessionName: initialData.sessionName || "",
        availableATV: initialData.availableATV || 0,
      });
    }
  }, [initialData]);

  return (
    <form
      onSubmit={handleBeforeSubmit}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Nama Sesi */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="sessionName"
            className="col-sm-4 col-form-label text-end"
            style={{ fontSize: "14px" }}
          >
            Nama Sesi:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.sessionName && "is-invalid"
              )}
              id="sessionName"
              placeholder="Nama Sesi"
              name="sessionName"
              value={formData.sessionName}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.sessionName && (
              <div className="invalid-feedback">{formError.sessionName}</div>
            )}
          </div>
        </div>

        {/* Jumlah ATV Tersedia */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="availableATV"
            className="col-sm-4 col-form-label text-end"
            style={{ fontSize: "14px" }}
          >
            Ketersediaan ATV:
          </label>
          <div className="col-sm-8">
            <input
              type="number"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.availableATV && "is-invalid"
              )}
              id="availableATV"
              placeholder="Jumlah ATV Tersedia"
              name="availableATV"
              value={formData.availableATV}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              min="0"
            />
            {formError?.availableATV && (
              <div className="invalid-feedback">{formError.availableATV}</div>
            )}
          </div>
        </div>
      </div>

      {/* Tombol Submit */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Sesi" : 
          "Update Sesi"
          // "Create Sesi"
          }
        </button>
      </div>
    </form>
  );
};

export default EditSessionPage;
